import { useState, useEffect } from 'react';
import Sidebar from './Sidebar';
import Navbar from './Navbar';
import * as XLSX from "xlsx";
import { FaDownload } from "react-icons/fa";
import "react-datepicker/dist/react-datepicker.css";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const InvoiceGen = () => {
    const [doctorInvoice, setDoctorInvoice] = useState([]);
    const [filter, setFilter] = useState('');
    const [selectedRows, setSelectedRows] = useState([]);
    const [selectAll, setSelectAll] = useState(false);
    const [selectedMonth, setSelectedMonth] = useState(null);
    const [selectedYear, setSelectedYear] = useState(null);
    const [loading, setLoading] = useState(false);
    const [categoryList, setCategoryList] = useState([]);
    const [isSearchClicked, setIsSearchClicked] = useState(false);
    const [modalData, setModalData] = useState(null);

    const [showModal, setShowModal] = useState(false);
    const [modalData1, setModalData1] = useState(null);
    const [modalData2, setModalData2] = useState(null);
    const [showModal1, setShowModal1] = useState(false);
    const [showModal2, setShowModal2] = useState(false);
    const [searchQuery, setSearchQuery] = useState(''); // Search query state
    const [selectedBMID, setSelectedBMID] = useState(null);
    const [selectedBMNAME, setSelectedBMNAME] = useState(null);
    const years = Array.from({ length: 12 }, (_, i) => 2024 + i);
    const months = [
        'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'
    ];

    useEffect(() => {
        const token = localStorage.getItem("jwt_token");

        const fetchCategoriesList = async () => {
            try {
                const response = await fetch(`${API_BASE_URL}api/getCategoriesList`, {
                    method: 'GET',
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    },
                });
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                const data = await response.json();
                if (Array.isArray(data.data)) {
                    setCategoryList(data.data);

                    console.log('Doctors:', data);
                } else {
                    console.error('Data is not an array:', data);
                    setCategoryList([]);
                }
            } catch (error) {
                console.error('Error:', error);
            }
        };

        fetchCategoriesList();
    }, []);

    useEffect(() => {
        if (isSearchClicked) {
            const fetchDoctorsInvoice = async () => {
                setLoading(true);
                const token = localStorage.getItem("jwt_token");

                try {
                    const url = new URL(`${API_BASE_URL}api/getDoctorInvoice`);
                    const params = {};

                    if (filter) params.filter = filter;
                    if (selectedMonth) {
                        const monthIndex = months.indexOf(selectedMonth);
                        if (monthIndex !== -1) params.month = monthIndex;
                    }
                    if (selectedYear) params.year = selectedYear;

                    url.search = new URLSearchParams(params).toString();

                    // Log the final URL to check if it's correct
                    console.log('Request URL:', url);

                    const response = await fetch(url, {
                        method: 'GET',
                        headers: {
                            'Authorization': `Bearer ${token}`,
                            'Content-Type': 'application/json'
                        }
                    });

                    //if (!response.ok) throw new Error('Network response was not ok');

                    const datak = await response.json();

                    // Log the API response for debugging
                    console.log('KRK Response:', datak);

                    // Handle case where no data is found
                    if (datak.message === 'No data found.') {
                        setDoctorInvoice([]); // No data found
                        alert('No data found for the selected filters.');
                    } else if (Array.isArray(datak.data1) && datak.data1.length > 0) {
                        setDoctorInvoice(datak.data1);
                    } else {
                        setDoctorInvoice([]); // Empty array if no data
                    }
                } catch (error) {
                    console.error('Error fetching doctor invoices:', error);
                    setDoctorInvoice([]);
                } finally {
                    setLoading(false);
                }
            };

            fetchDoctorsInvoice();
        }
    }, [isSearchClicked, filter, selectedMonth, selectedYear]);



    // Handle the click event on Reporting_Radiologist_BMID to open the modal




    const handleRowClick = async (reportingRadiologistBMID, Reporting_Radiologist_Name) => {
        const token = localStorage.getItem("jwt_token");

        // Debugging: Log API details
        console.log("Fetching invoice for BMID:", reportingRadiologistBMID);
        console.log("API URL:", `${API_BASE_URL}api/getDoctorsInvoiceByid/${reportingRadiologistBMID}/${selectedMonth}/${selectedYear}`);

        try {
            const response = await fetch(`${API_BASE_URL}api/getDoctorsInvoiceByid/${reportingRadiologistBMID}/${selectedMonth}/${selectedYear}`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            console.log("Response Status:", response.status);

            if (!response.ok) {
                const errorText = await response.text();
                throw new Error(`Failed to fetch detailed invoice data: ${errorText}`);
            }

            const data = await response.json();
            console.log("Fetched Invoice Data:", data);

            if (data?.data) {
                setSelectedBMID(reportingRadiologistBMID);
                setSelectedBMNAME(Reporting_Radiologist_Name);
                setModalData(data.data); // Set fetched data into the modal
                setShowModal(true);      // Show modal
            } else {
                console.warn("No data received from API");
            }
        } catch (error) {
            console.error("Error fetching invoice by ID:", error);
        }
    };

    const handleInvoiceByCategory = async (reportingRadiologistBMID, time_difference_hours, working_hrs, totalDays, lop_days) => {
        const token = localStorage.getItem("jwt_token");

        // Debugging: Log API details
        console.log("Fetching invoice for BMID:", reportingRadiologistBMID);
        console.log("API URL:", `${API_BASE_URL}api/getDoctorsInvoiceByCategory/${reportingRadiologistBMID}/${selectedMonth}/${selectedYear}/${time_difference_hours}/${working_hrs}/${totalDays}/${lop_days}`);

        try {
            const response = await fetch(`${API_BASE_URL}api/getDoctorsInvoiceByCategory/${reportingRadiologistBMID}/${selectedMonth}/${selectedYear}/${time_difference_hours}/${working_hrs}/${totalDays}/${lop_days}`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            console.log("Response Status:", response.status);

            if (!response.ok) {
                const errorText = await response.text();
                throw new Error(`Failed to fetch detailed invoice data: ${errorText}`);
            }

            const data = await response.json();
            console.log("Fetched Invoice Data:", data);

            if (data?.data) {
                setModalData1(data.data); // Set fetched data into the modal
                setShowModal1(true);      // Show modal
                setSelectedBMID(reportingRadiologistBMID);

            } else {
                console.warn("No data received from API");
            }
        } catch (error) {
            console.error("Error fetching invoice by ID:", error);
        }
    };
    const handleInvoiceByCategory_attn = async (reportingRadiologistBMID, time_difference_hours, working_hrs, totalDays, lop_days) => {
        const token = localStorage.getItem("jwt_token");

        // Debugging: Log API details
        console.log("Fetching invoice for BMID:", reportingRadiologistBMID);
        console.log("API URL:", `${API_BASE_URL}api/getDoctorsInvoiceByCategory_attn/${reportingRadiologistBMID}/${selectedMonth}/${selectedYear}/${time_difference_hours}/${working_hrs}/${totalDays}/${lop_days}`);

        try {
            const response = await fetch(`${API_BASE_URL}api/getDoctorsInvoiceByCategory_attn/${reportingRadiologistBMID}/${selectedMonth}/${selectedYear}/${time_difference_hours}/${working_hrs}/${totalDays}/${lop_days}`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            console.log("Response Status:", response.status);

            if (!response.ok) {
                const errorText = await response.text();
                throw new Error(`Failed to fetch detailed invoice data: ${errorText}`);
            }

            const data = await response.json();
            console.log("Fetched Invoice Data:", data);

            if (data?.data) {
                setModalData2(data.data); // Set fetched data into the modal
                setShowModal2(true);      // Show modal
                setSelectedBMID(reportingRadiologistBMID);
            } else {
                console.warn("No data received from API");
            }
        } catch (error) {
            console.error("Error fetching invoice by ID:", error);
        }
    };





    const handleSelectRow = (id) => {
        setSelectedRows(prevState => {
            if (prevState.includes(id)) {
                return prevState.filter(rowId => rowId !== id);
            } else {
                return [...prevState, id];
            }
        });
    };

    const handleSelectAll = () => {
        if (selectAll) {
            setSelectedRows([]);
        } else {
            setSelectedRows(doctorInvoice.map(row => row.id));
        }
        setSelectAll(!selectAll);
    };

    // Filter doctorInvoice based on search query
    const filteredDoctorInvoice = doctorInvoice.filter((invoice) => {
        const { Reporting_Radiologist_BMID, Reporting_Radiologist_Name, cnt } = invoice;
        const query = searchQuery.toLowerCase();
        return (
            Reporting_Radiologist_BMID.toLowerCase().includes(query) ||
            Reporting_Radiologist_Name.toLowerCase().includes(query) ||
            cnt.toString().includes(query)
        );
    });

    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);
    };

    const handleSearchClick = () => {
        if (filter && selectedMonth !== null && selectedYear !== null) {
            setIsSearchClicked(true);
        } else {
            alert('Please select all filters before searching.');
        }
    };

    const getTestCategoryById = (categoryId) => {
        const category = categoryList.find(cat => cat.id === categoryId);
        return category ? category.test_category : 'Unknown Category';
    };


    const totalAmt = (modalData || []).reduce((sum, row) => sum + (parseFloat(row.amt) || 0), 0);
    const totalCalAmt = (modalData || []).reduce((sum, row) => sum + (parseFloat(row.cal_total_amt) || 0), 0);

    const totalSelectedAmount = filteredDoctorInvoice
        .filter(row => selectedRows.includes(row.Reporting_Radiologist_BMID)) // Get only selected rows
        .reduce((sum, row) => sum + (parseFloat(row.total_amt) || 0), 0); // Convert total_amt to number safely
    const deviationAndLopAmounts = filteredDoctorInvoice
        .filter(row => selectedRows.includes(row.Reporting_Radiologist_BMID))
        .map(row => {
            const professionalCharges = row.professional_charges
                ? parseFloat(row.professional_charges.replace(/,/g, '')) || 0
                : 0;

            const totalDays = parseFloat(row.totalDays) || 1; // Avoid division by zero
            const lopDays = parseFloat(row.lop_days) || 0;
            const workingHours = parseFloat(row.working_hrs) || 1;
            const timeDifferenceHours = parseFloat(row.time_difference_hours) || 0;
            const incentiveAmount = row.insentive_amt
                ? parseFloat(row.insentive_amt.replace(/,/g, '')) || 0
                : 0;

            // Lop Amount Calculation
            const lopAmount = (professionalCharges / totalDays) * lopDays;

            // Time Deviation Amount Calculation
            const timeDeviationAmount = (professionalCharges / (totalDays * workingHours * 60)) * Math.round(timeDifferenceHours * 60);

            return {
                lopAmount,
                timeDeviationAmount
            };
        });

    console.log("All Lop and Time Deviation Amounts:", deviationAndLopAmounts);
    const lopAmount = deviationAndLopAmounts[0]?.lopAmount || 0;
    const timeDeviationAmount = deviationAndLopAmounts[0]?.timeDeviationAmount || 0;
    const handleInvoiceGeneration = async () => {
        const isConfirmed = window.confirm("Are you sure you want to generate the invoice?");
        if (!isConfirmed) return;
        const token = localStorage.getItem("jwt_token");

        // Collect the selected rows' data
        const selectedData = filteredDoctorInvoice
            .filter(row => selectedRows.includes(row.Reporting_Radiologist_BMID))

            .map(row => ({

                Reporting_Radiologist_BMID: row.Reporting_Radiologist_BMID,
                Reporting_Radiologist_Name: row.Reporting_Radiologist_Name,
                Lop_Days: row.lop_days,
                Time_Deviation_Minutes: Math.round(row.time_difference_hours * 60),
                Time_Deviation_Amount: Math.round(timeDeviationAmount),
                Lop_Amount: Math.round(lopAmount),
                doc_type: row.doc_type,
                cnt: row.cnt,
                total_amt: row.total_amt,
                month: selectedMonth, // Adding month in each object
                year: selectedYear // Adding year in each object
            }));
        const doct_code = selectedData.length > 0 ? selectedData[0].Reporting_Radiologist_BMID : null;


        const months = [
            "January", "February", "March", "April", "May", "June",
            "July", "August", "September", "October", "November", "December"
        ];

        const monthIndex = months.indexOf(selectedMonth);
        const payload = {
            doct_code,
            month: monthIndex,
            year: selectedYear,
            data: selectedData
        };

        try {
            const response = await fetch(`${API_BASE_URL}api/saveDoctorInfo`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(payload)
            });

            if (!response.ok) {
                throw new Error('Failed to save doctor info');
            }

            const data = await response.json();
            console.log('Doctor info saved successfully:', data);

            // Optionally, you can show a success message or reset the selected rows
            setSelectedRows([]);
            setSelectAll(false);
            alert('Invoice data saved successfully!');
            window.location.reload();
        } catch (error) {
            console.error('Error saving doctor info:', error);
            alert('Failed to save invoice data. Please try again.');
        }
    };

    const downloadExcel = () => {
        if (!modalData || modalData.length === 0) return;

        // Example values (replace with your actual state/props)
        const selectedDoctor = doctorInvoice.find(
            (doc) => doc.Reporting_Radiologist_BMID === selectedBMID
        );

        const radiologistName = selectedDoctor
            ? selectedDoctor.Reporting_Radiologist_Name
            : "N/A";

        // Define worksheet data
        const wsData = [
            // First row: BM ID and Doctor Name
            [`Category Invoice - ${selectedBMID} - ${radiologistName} - ${selectedMonth}`],
            [], // Empty row for spacing
            [
                "#",
                "Register Date",
                "Branch",
                "Lab ID",
                "Patient Name",
                "Service ID",
                "Service Name",
                "Amount",
                "Amount Type",
                "Target",
                "Study Desc",
                "Main Category"
            ],
            ...modalData.map((row, index) => [
                index + 1,
                row.register_date,
                row.branch,
                row.labid,
                row.patient_name,
                row.service_id,
                row.service_name,
                row.revenue,
                row.cal_total_amt,
                row.amt,
                row.amt_type,
                row.target,
                row.study_desc,
                row.service_id === "OD"
                    ? "Duplicate"
                    : row.service_id === "No Pay"
                    ? "No Pay"
                    : getTestCategoryById(row.Main_category) // category or "Duplicate"
            ])
        ];

        // Create worksheet
        const ws = XLSX.utils.aoa_to_sheet(wsData);

        // Create workbook and append sheet
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Detailed Invoice");

        // Save file
        XLSX.writeFile(wb, "detailed_invoice.xlsx");
    };


    const downloadExcel1 = () => {
        if (!modalData1 || !Array.isArray(modalData1) || modalData1.length === 0) {
            console.error("No data available for export.");
            return;
        }

        const selectedDoctor = doctorInvoice.find(
            (doc) => doc.Reporting_Radiologist_BMID === selectedBMID
        );

        const radiologistName = selectedDoctor
            ? selectedDoctor.Reporting_Radiologist_Name
            : "N/A";

        // Calculate totals
        const totalCases = modalData1.reduce((total, row) => total + (parseFloat(row.cnt) || 0), 0);
        const totalAmount = modalData1.reduce((total, row) => total + ((parseFloat(row.amt) || 0) * (parseFloat(row.cnt) || 0)), 0);

        // Define column headers and map data accordingly
        const wsData = [
            [`Category Invoice - ${selectedBMID} - ${radiologistName} - ${selectedMonth}`],
            [], // Empty row for spacing
            [
                "#",
                "Category",
                "Amount Type",
                "Actuals Target",
                "Amount",
                "No. Of Cases Reported",
                "Total Amount",
            ],
            ...modalData1.map((row, index) => [
                index + 1,

                row.test_category || "", // Prevent undefined values
                row.amt_type || "",
                row.target || 0,
                row.amt || 0,
                row.cnt || 0,
                (row.amt || 0) * (row.cnt || 0),
            ]),
            // Append the total row at the bottom
            [
                "Total", "", "", "", "", totalCases, totalAmount
            ]
        ];








        // Create a worksheet
        const ws = XLSX.utils.aoa_to_sheet(wsData);

        // Create a workbook and append the worksheet
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Category Invoice");

        // Save the Excel file
        XLSX.writeFile(wb, "Category_invoice.xlsx");
    };
    // const totaldeduction_fixed = filteredDoctorInvoice.reduce((totaldeduction_fixed, row) => {
    //     const deductedAmount =
    //       (parseFloat(row.professional_charges.replace(/,/g, '')) || 0) / 
    //       (parseFloat(row.totalDays) || 1) *  
    //       (parseFloat(row.lop_days) || 0)  
    //     + 
    //       ((parseFloat(row.professional_charges.replace(/,/g, '')) || 0) / 
    //       ((parseFloat(row.totalDays) || 1) * (parseFloat(row.working_hrs) || 1) * 60))  
    //       * Math.round(parseFloat(row.time_difference_hours) * 60);

    //     return totaldeduction_fixed + deductedAmount; // Accumulate the total sum
    //   }, 0); 


    const totaldeduction_fixed = filteredDoctorInvoice.reduce((totaldeduction_fixed, row) => {
        if (!row.professional_charges) return totaldeduction_fixed; // Skip if undefined

        const professionalCharges = parseFloat(row.professional_charges.replace(/,/g, '')) || 0;
        const totalDays = parseFloat(row.totalDays) || 1;
        const lopDays = parseFloat(row.lop_days) || 0;
        const workingHours = parseFloat(row.working_hrs) || 1;
        const timeDifferenceMinutes = Math.round(parseFloat(row.time_difference_hours) * 60) || 0;

        const deductedAmount =
            (professionalCharges / totalDays) * lopDays +
            (professionalCharges / (totalDays * workingHours * 60)) * timeDifferenceMinutes;

        return totaldeduction_fixed + deductedAmount; // Accumulate the total sum
    }, 0);

    const formatTotalTime = (data) => {
        if (!Array.isArray(data)) return '00:00:00';

        let totalSeconds = data.reduce((total, row) => {
            if (!row.time) return total;
            const [h = '0', m = '0', s = '0'] = row.time.split('.');
            return total + (+h * 3600) + (+m * 60) + (+s);
        }, 0);

        const hours = Math.floor(totalSeconds / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;

        const pad = (n) => String(n).padStart(2, '0');
        return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
    };



    return (
        <div className="wrapper">
            <Sidebar />
            <main className="main-content content-page">
                <div className="position-relative">
                    <Navbar />
                </div>
                <div className="content-inner container-fluid pb-0" id="page_layout">
                    <div>
                        <div className="row">
                            <div className="col-sm-12">
                                <div className="card">
                                    <div className="card-header-custom d-flex justify-content-between p-4 mb-0 row">
                                        <div className="col-md-3">
                                            <div className="header-title">
                                                <h4 className="card-title">Doctor Invoices</h4>
                                            </div>
                                        </div>
                                        <div className="col-md-9 d-flex" style={{ gap: '2%' }}>
                                            <div className="form-group" style={{ width: '100%' }}>
                                                <select
                                                    value={filter}
                                                    onChange={(e) => setFilter(e.target.value)}
                                                    className="form-control"
                                                >
                                                    <option value="">Select Doctor Type</option>
                                                    <option value="All">All</option>
                                                    <option value="Fixed">Fixed</option>
                                                    <option value="Target">Target</option>
                                                    <option value="Case Base">Case Based</option>
                                                </select>
                                            </div>
                                            <div className="form-group" style={{ width: '100%' }}>
                                                <select
                                                    value={selectedMonth}
                                                    onChange={(e) => setSelectedMonth(e.target.value)}
                                                    className="form-control"
                                                >
                                                    <option value="">Select Month</option>
                                                    {months.map((month, index) => (
                                                        <option key={index} value={month}>
                                                            {month}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                            <div className="form-group" style={{ width: '100%' }}>
                                                <select
                                                    value={selectedYear}
                                                    onChange={(e) => setSelectedYear(parseInt(e.target.value))}
                                                    className="form-control"
                                                >
                                                    <option value="">Select Year</option>
                                                    {years.map((year) => (
                                                        <option key={year} value={year}>
                                                            {year}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                            <div
                                                className="input-group-text"
                                                onClick={handleSearchClick}
                                                style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    cursor: 'pointer',
                                                    height: '38px',
                                                    width: '38px',
                                                    backgroundColor: '#f1f1f1',
                                                    borderRadius: '5px',
                                                    boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',
                                                }}
                                            >
                                                <svg
                                                    className="icon-20 text-primary"
                                                    width="20"
                                                    height="20"
                                                    viewBox="0 0 24 24"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <circle cx="11.7669" cy="11.7666" r="8.98856" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></circle>
                                                    <path d="M18.0186 18.4851L21.5426 22" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                                                </svg>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {loading ? (
                                    <div>Loading...</div>
                                ) : (
                                    <div style={{ maxHeight: '800px', overflowY: 'auto', overflowX: 'auto' }}>
                                        <input
                                            type="text"
                                            value={searchQuery}
                                            onChange={handleSearchChange}
                                            placeholder="Search by BM ID, Name, or Count"
                                            className="form-control mb-4"
                                        />

                                        {selectedRows.length > 0 && (
                                            <div style={{ textAlign: 'right', display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
                                                <button className="btn btn-success" onClick={handleInvoiceGeneration}>Invoice Generation</button>
                                                <button className="btn btn-primary">Total: ₹{totalSelectedAmount.toFixed(2)}</button>
                                            </div>
                                        )}

                                        <table style={{ width: '100%', borderCollapse: 'collapse', borderRadius: '10px' }} className="table table-striped table-bordered table-hover">
                                            <thead style={{ backgroundColor: '#089bab', color: 'white', fontWeight: 'bold', textAlign: 'center' }}>
                                                <tr>
                                                    <th>
                                                        <input type="checkbox" checked={selectAll} onChange={handleSelectAll} />
                                                    </th>
                                                    <th>S.No</th>
                                                    <th>Radiologist BM Id</th>
                                                    <th>Radiologist Name</th>
                                                    {filter === 'Target' ? (
                                                        <>
                                                            <th>Lop Days</th>
                                                            <th>Time Deviation (Mins)</th>
                                                            <th>Fixed Gross</th>
                                                            <th>Lop Amount</th>
                                                            <th>Time Deviation Amount</th>
                                                            <th>Total Deductions</th>
                                                            <th>Gross Amount</th>
                                                            <th>Incentive</th>
                                                            <th>Net Amount</th>
                                                        </>
                                                    ) : (
                                                        <>
                                                            <th>Pay</th>
                                                            <th>No. of Cases</th>
                                                            <th>Total Amount</th>
                                                        </>
                                                    )}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {doctorInvoice.length > 0 ? (
                                                    doctorInvoice.map((row, index) => {
                                                        const professionalCharges = row.professional_charges
                                                            ? parseFloat(row.professional_charges.replace(/,/g, '')) || 0
                                                            : 0;

                                                        const totalDays = parseFloat(row.totalDays) || 1; // Avoid division by zero
                                                        const lopDays = parseFloat(row.lop_days) || 0;
                                                        const workingHours = parseFloat(row.working_hrs) || 1;
                                                        const timeDifferenceHours = parseFloat(row.time_difference_hours) || 0;
                                                        const incentiveAmount = row.insentive_amt
                                                            ? parseFloat(row.insentive_amt.replace(/,/g, '')) || 0
                                                            : 0;

                                                        // Lop Amount Calculation
                                                        const lopAmount = (professionalCharges / totalDays) * lopDays;

                                                        // Time Deviation Amount Calculation
                                                        const timeDeviationAmount = (professionalCharges / (totalDays * workingHours * 60)) * Math.round(timeDifferenceHours * 60);

                                                        // Total Deductions
                                                        const totalDeductionFixed = lopAmount + timeDeviationAmount;

                                                        // Gross Amount Calculation
                                                        const grossAmount = professionalCharges - totalDeductionFixed;

                                                        // Net Amount Calculation
                                                        const netAmount = grossAmount + incentiveAmount;





                                                        return (
                                                            <tr key={row.Reporting_Radiologist_BMID} style={{ backgroundColor: '#f9f9f9' }}>
                                                                <td style={{ textAlign: 'center' }}>
                                                                    <input
                                                                        type="checkbox"
                                                                        checked={selectedRows.includes(row.Reporting_Radiologist_BMID)}
                                                                        onChange={() => handleSelectRow(row.Reporting_Radiologist_BMID)}
                                                                    />
                                                                </td>
                                                                <td style={{ textAlign: 'center' }}>{index + 1}</td>
                                                                <td style={{ textAlign: 'center' }} onClick={() => handleRowClick(row.Reporting_Radiologist_BMID, row.Reporting_Radiologist_Name)}>
                                                                    {row.Reporting_Radiologist_BMID}
                                                                </td>
                                                                <td style={{ textAlign: 'center' }} onClick={() => handleInvoiceByCategory(row.Reporting_Radiologist_BMID, row.time_difference_hours, row.working_hrs, row.totalDays, row.lop_days)}>
                                                                    {row.Reporting_Radiologist_Name}
                                                                </td>

                                                                {filter === 'Target' ? (
                                                                    <>

                                                                        <td style={{ textAlign: 'center' }} onClick={() => handleInvoiceByCategory_attn(row.Reporting_Radiologist_BMID, row.time_difference_hours, row.working_hrs, row.totalDays, row.lop_days)}>
                                                                            {row.lop_days}
                                                                        </td>

                                                                        {/* <td style={{ textAlign: 'center' }}>{row.lop_days}</td> */}
                                                                        <td style={{ textAlign: 'center' }}>{Math.round(row.time_difference_hours * 60)}</td>
                                                                        <td style={{ textAlign: 'center' }}>{row.professional_charges}</td>
                                                                        <td style={{ textAlign: 'center' }}>{lopAmount.toFixed(2)}</td>
                                                                        <td style={{ textAlign: 'center' }}>{timeDeviationAmount.toFixed(2)}</td>
                                                                        <td style={{ textAlign: 'center' }}>{totalDeductionFixed.toFixed(2)}</td>
                                                                        <td style={{ textAlign: 'center' }}>{grossAmount.toFixed(2)}</td>
                                                                        <td style={{ textAlign: 'center' }}>{row.insentive_amt}</td>
                                                                        <td style={{ textAlign: 'center' }}>{netAmount.toFixed(2)}</td>
                                                                    </>
                                                                ) : (
                                                                    <>
                                                                        <td style={{ textAlign: 'center' }}>{row.doc_type}</td>
                                                                        <td style={{ textAlign: 'center' }}>{row.cnt}</td>
                                                                        <td style={{ textAlign: 'center' }}>{row.total_amt}</td>
                                                                    </>
                                                                )}
                                                            </tr>
                                                        );
                                                    })
                                                ) : (
                                                    <tr>
                                                        <td colSpan={filter === 'Target' ? 13 : 7} style={{ textAlign: 'center', fontWeight: 'bold', padding: '20px' }}>
                                                            No records found
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                )}
                                {/* Modal for displaying detailed data */}
                                {showModal && modalData && (
                                    <div className="modal" style={{ display: 'block', overflow: 'hidden', zIndex: 9999 }}>
                                        <div
                                            className="modal-content"
                                            style={{
                                                padding: '20px',
                                                maxWidth: '80%',
                                                margin: 'auto',
                                                backgroundColor: '#fff',
                                                borderRadius: '10px',
                                                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                                                maxHeight: '80vh', // Limit modal height
                                                overflow: 'hidden', // Hide overflow on the modal
                                            }}
                                        >
                                            <span
                                                className="close"
                                                onClick={() => setShowModal(false)}
                                                style={{
                                                    float: 'right',
                                                    cursor: 'pointer',
                                                    fontSize: '30px',
                                                    color: '#aaa',
                                                    fontWeight: 'bold',
                                                }}
                                            >
                                                &times;
                                            </span>
                                            <h2 style={{ textAlign: 'center', marginBottom: '20px', display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '10px' }}>
                                                Detailed Invoice ({selectedBMID || 'N/A'}, {selectedBMNAME || 'Unknown'})
                                                <FaDownload
                                                    style={{ cursor: "pointer", color: "#007bff", fontSize: "24px" }}
                                                    onClick={downloadExcel}
                                                    title="Download Excel"
                                                />
                                            </h2>
                                            {/* Render modal data in a table */}
                                            <div
                                                style={{
                                                    width: '100%',
                                                    overflow: 'auto',
                                                    maxHeight: '60vh', // Set max height for the table
                                                    border: '1px solid #ddd',
                                                    borderRadius: '8px',
                                                    boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',
                                                }}
                                            >
                                                <table
                                                    style={{
                                                        width: '100%',
                                                        borderCollapse: 'collapse',
                                                    }}
                                                >
                                                    <thead>
                                                        <tr>
                                                            <th style={{ padding: '12px', border: '1px solid #ddd', backgroundColor: '#f1f1f1' }}>
                                                                #
                                                            </th>
                                                            <th style={{ padding: '12px', border: '1px solid #ddd', backgroundColor: '#f1f1f1' }}>
                                                                Register date
                                                            </th>
                                                            <th style={{ padding: '12px', border: '1px solid #ddd', backgroundColor: '#f1f1f1' }}>
                                                                Branch
                                                            </th>
                                                            <th style={{ padding: '12px', border: '1px solid #ddd', backgroundColor: '#f1f1f1' }}>
                                                                Lab ID
                                                            </th>
                                                            <th style={{ padding: '12px', border: '1px solid #ddd', backgroundColor: '#f1f1f1' }}>
                                                                Patient Name
                                                            </th>
                                                            <th style={{ padding: '12px', border: '1px solid #ddd', backgroundColor: '#f1f1f1' }}>
                                                                Service ID
                                                            </th>
                                                            <th style={{ padding: '12px', border: '1px solid #ddd', backgroundColor: '#f1f1f1' }}>
                                                                Service Name
                                                            </th>
                                                            <th style={{ padding: '12px', border: '1px solid #ddd', backgroundColor: '#f1f1f1' }}>
                                                                Revenue
                                                            </th>
                                                            <th style={{ padding: '12px', border: '1px solid #ddd', backgroundColor: '#f1f1f1' }}>
                                                                Calculated Amount
                                                            </th>

                                                            <th style={{ padding: '12px', border: '1px solid #ddd', backgroundColor: '#f1f1f1' }}>
                                                                Amount
                                                            </th>
                                                            <th style={{ padding: '12px', border: '1px solid #ddd', backgroundColor: '#f1f1f1' }}>
                                                                Amount Type
                                                            </th>
                                                            <th style={{ padding: '12px', border: '1px solid #ddd', backgroundColor: '#f1f1f1' }}>
                                                                Target
                                                            </th>
                                                            <th style={{ padding: '12px', border: '1px solid #ddd', backgroundColor: '#f1f1f1' }}>
                                                                Study Desc
                                                            </th>
                                                            <th style={{ padding: '12px', border: '1px solid #ddd', backgroundColor: '#f1f1f1' }}>
                                                                Main Category
                                                            </th>

                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {modalData.map((row, index) => (
                                                            <tr key={row.id}>
                                                                <td style={{ textAlign: "center" }}>{index + 1}</td>
                                                                <td style={{ padding: "8px", border: "1px solid #ddd" }}>
                                                                    {row.register_date}
                                                                </td>
                                                                <td style={{ padding: "8px", border: "1px solid #ddd" }}>
                                                                    {row.branch}
                                                                </td>
                                                                <td style={{ padding: "8px", border: "1px solid #ddd" }}>
                                                                    {row.labid}
                                                                </td>
                                                                <td style={{ padding: "8px", border: "1px solid #ddd" }}>
                                                                    {row.patient_name}
                                                                </td>
                                                                <td style={{ padding: "8px", border: "1px solid #ddd" }}>
                                                                    {row.service_id}
                                                                </td>
                                                                <td style={{ padding: "8px", border: "1px solid #ddd" }}>
                                                                    {row.service_name}
                                                                </td>
                                                                <td style={{ padding: "8px", border: "1px solid #ddd" }}>
                                                                    {row.revenue}
                                                                </td>
                                                                <td style={{ padding: "8px", border: "1px solid #ddd" }}>
                                                                    {row.cal_total_amt}
                                                                </td>
                                                                {row.amt === "Not Mapped" ? (
                                                                    <td
                                                                        style={{
                                                                            padding: "8px",
                                                                            border: "1px solid #ddd",
                                                                            color: "red",
                                                                        }}
                                                                    >
                                                                        {row.amt}
                                                                    </td>
                                                                ) : (
                                                                    <td style={{ padding: "8px", border: "1px solid #ddd" }}>
                                                                        {row.amt}
                                                                    </td>
                                                                )}
                                                                <td style={{ padding: "8px", border: "1px solid #ddd" }}>
                                                                    {row.amt_type}
                                                                </td>
                                                                <td style={{ padding: "8px", border: "1px solid #ddd" }}>
                                                                    {row.target}
                                                                </td>
                                                                <td style={{ padding: "8px", border: "1px solid #ddd" }}>
                                                                    {row.study_desc}
                                                                </td>
                                                                <td style={{ padding: "8px", border: "1px solid #ddd" }}>
                                                                    {row.service_id === "OD"
                                                                        ? "Duplicate"
                                                                        : row.service_id === "No Pay"
                                                                            ? "No Pay"
                                                                            : getTestCategoryById(row.Main_category)}
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>


                                                    <tfoot>
                                                        <tr>
                                                            <td colSpan="8" style={{ padding: '8px', border: '1px solid #ddd', fontWeight: 'bold' }}>Total Amounts:</td>
                                                            
                                                            <td style={{ padding: '8px', border: '1px solid #ddd', fontWeight: 'bold' }}>Total Cal Amount{totalCalAmt}</td>
                                                            <td style={{ padding: '8px', border: '1px solid #ddd', fontWeight: 'bold' }}>Total Amount {totalAmt}</td>
                                                        </tr>
                                                    </tfoot>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                )}







                                {showModal1 && modalData1 && (
                                    <div className="modal" style={{ display: 'block', overflow: 'hidden', zIndex: 9999 }}>
                                        <div
                                            className="modal-content"
                                            style={{
                                                padding: '20px',
                                                maxWidth: '80%',
                                                margin: 'auto',
                                                backgroundColor: '#fff',
                                                borderRadius: '10px',
                                                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                                                maxHeight: '80vh', // Limit modal height
                                                overflow: 'hidden', // Hide overflow on the modal
                                            }}
                                        >
                                            <span
                                                className="close"
                                                onClick={() => setShowModal1(false)}
                                                style={{
                                                    float: 'right',
                                                    cursor: 'pointer',
                                                    fontSize: '30px',
                                                    color: '#aaa',
                                                    fontWeight: 'bold',
                                                }}
                                            >
                                                &times;
                                            </span>
                                            <h2 style={{ textAlign: 'center', marginBottom: '20px', display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '10px' }}>
                                                Category Invoice - {selectedBMID}
                                                <FaDownload
                                                    style={{ cursor: "pointer", color: "#007bff", fontSize: "24px" }}
                                                    onClick={downloadExcel1}
                                                    title="Download Excel"
                                                />
                                            </h2>
                                            {/* Render modal data in a table */}
                                            <div
                                                style={{
                                                    width: '100%',
                                                    overflow: 'auto',
                                                    maxHeight: '60vh', // Set max height for the table
                                                    border: '1px solid #ddd',
                                                    borderRadius: '8px',
                                                    boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',
                                                }}
                                            >
                                                <table
                                                    style={{
                                                        width: '100%',
                                                        borderCollapse: 'collapse',
                                                    }}
                                                >
                                                    <thead>
                                                        <tr>
                                                            <th style={{ padding: '12px', border: '1px solid #ddd', backgroundColor: '#f1f1f1' }}>
                                                                #
                                                            </th>
                                                            <th style={{ padding: '12px', border: '1px solid #ddd', backgroundColor: '#f1f1f1' }}>
                                                                Test Category
                                                            </th>


                                                            <th style={{ padding: '12px', border: '1px solid #ddd', backgroundColor: '#f1f1f1' }}>
                                                                Actuals Target
                                                            </th>

                                                            <th style={{ padding: '12px', border: '1px solid #ddd', backgroundColor: '#f1f1f1' }}>
                                                                Lop Target
                                                            </th>
                                                            <th style={{ padding: '12px', border: '1px solid #ddd', backgroundColor: '#f1f1f1' }}>
                                                                Revised Target
                                                            </th>
                                                            <th style={{ padding: '12px', border: '1px solid #ddd', backgroundColor: '#f1f1f1' }}>
                                                                Actual No. Of Cases Reported
                                                            </th>
                                                            <th style={{ padding: '12px', border: '1px solid #ddd', backgroundColor: '#f1f1f1' }}>
                                                                Variance In cases
                                                            </th>
                                                            <th style={{ padding: '12px', border: '1px solid #ddd', backgroundColor: '#f1f1f1' }}>
                                                                Incentive Rate
                                                            </th>

                                                            <th style={{ padding: '12px', border: '1px solid #ddd', backgroundColor: '#f1f1f1' }}>
                                                                Incentive Amount
                                                            </th>


                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {modalData1.map((row, index) => (
                                                            <tr key={row.id}>
                                                                <td style={{ textAlign: 'center' }}>
                                                                    {index + 1}
                                                                </td>
                                                                <td style={{ padding: '8px', border: '1px solid #ddd' }}>{row.test_category}({row.Main_category})</td>

                                                                {/* <td style={{ padding: '8px', border: '1px solid #ddd' }}>{row.amt_type }</td> */}
                                                                <td style={{ padding: '8px', border: '1px solid #ddd' }}>{row.target}</td>

                                                                <td style={{ padding: '8px', border: '1px solid #ddd' }}>{Math.floor((parseFloat(row.target) || 0) / row.totalDays * (parseFloat(row.lop) || 0))}</td>


                                                                <td style={{ padding: '8px', border: '1px solid #ddd' }}>
                                                                    {row.target - Math.floor((parseFloat(row.target) || 0) / row.totalDays * (parseFloat(row.lop) || 0))}
                                                                </td>
                                                                <td style={{ padding: '8px', border: '1px solid #ddd' }}>{row.cnt}</td>
                                                                <td style={{ padding: '8px', border: '1px solid #ddd' }}>
                                                                    {row.cnt - (row.target - Math.floor((parseFloat(row.target) || 0) / row.totalDays * (parseFloat(row.lop) || 0)))}</td>



                                                                <td style={{ padding: '8px', border: '1px solid #ddd' }}>{row.amt}</td>

                                                                <td style={{ padding: '8px', border: '1px solid #ddd' }}>
                                                                    {(row.cnt - (row.target - Math.floor((parseFloat(row.target) || 0) / row.totalDays * (parseFloat(row.lop) || 0)))) * row.amt}</td>

                                                            </tr>
                                                        ))}
                                                    </tbody>

                                                    <tfoot>
                                                        <tr>
                                                            <td colSpan="1" style={{ padding: '8px', border: '1px solid #ddd', fontWeight: 'bold' }}>Total:</td>

                                                            <td style={{ padding: '8px', border: '1px solid #ddd', fontWeight: 'bold' }}></td>
                                                            <td style={{ padding: '8px', border: '1px solid #ddd', fontWeight: 'bold' }}>
                                                                {modalData1.reduce((total, row) => total + (parseFloat(row.target) || 0), 0)}
                                                            </td>
                                                            <td colSpan="2" style={{ padding: '8px', border: '1px solid #ddd', fontWeight: 'bold' }}>
                                                            </td>
                                                            <td style={{ padding: '8px', border: '1px solid #ddd', fontWeight: 'bold' }}>
                                                                {modalData1.reduce((total, row) => total + (parseFloat(row.cnt) || 0), 0)}
                                                            </td>
                                                            <td colSpan="2"></td>
                                                            <td style={{ padding: '8px', border: '1px solid #ddd', fontWeight: 'bold' }}>
                                                                {modalData1.reduce((total, row) =>
                                                                    total + (row.cnt - (row.target - Math.floor((parseFloat(row.target) || 0) / row.totalDays * (parseFloat(row.lop) || 0)))) * row.amt
                                                                    , 0)}
                                                            </td>
                                                        </tr>
                                                    </tfoot>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                )}


                                {showModal2 && modalData2 && (
                                    <div className="modal" style={{ display: 'block', overflow: 'hidden', zIndex: 9999 }}>
                                        <div
                                            className="modal-content"
                                            style={{
                                                padding: '20px',
                                                maxWidth: '80%',
                                                margin: 'auto',
                                                backgroundColor: '#fff',
                                                borderRadius: '10px',
                                                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                                                maxHeight: '80vh', // Limit modal height
                                                overflow: 'hidden', // Hide overflow on the modal
                                            }}
                                        >
                                            <span
                                                className="close"
                                                onClick={() => setShowModal2(false)}
                                                style={{
                                                    float: 'right',
                                                    cursor: 'pointer',
                                                    fontSize: '30px',
                                                    color: '#aaa',
                                                    fontWeight: 'bold',
                                                }}
                                            >
                                                &times;
                                            </span>
                                            {/* <h2 style={{ textAlign: 'center', marginBottom: '20px', display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '10px' }}>
                                                Attendance - {selectedBMID}
                                                <FaDownload
                                                    style={{ cursor: "pointer", color: "#007bff", fontSize: "24px" }}
                                                    onClick={downloadExcel2}
                                                    title="Download Excel"
                                                />
                                            </h2> */}
                                            {/* Render modal data in a table */}
                                            <div
                                                style={{
                                                    width: '100%',
                                                    overflow: 'auto',
                                                    maxHeight: '60vh', // Set max height for the table
                                                    border: '1px solid #ddd',
                                                    borderRadius: '8px',
                                                    boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',
                                                }}
                                            >
                                                <table
                                                    style={{
                                                        width: '100%',
                                                        borderCollapse: 'collapse',
                                                    }}
                                                >
                                                    <thead>
                                                        <tr>
                                                            <th style={{ padding: '12px', border: '1px solid #ddd', backgroundColor: '#f1f1f1' }}>
                                                                #
                                                            </th>
                                                            <th style={{ padding: '12px', border: '1px solid #ddd', backgroundColor: '#f1f1f1' }}>
                                                                Date
                                                            </th>


                                                            {/* <th style={{ padding: '12px', border: '1px solid #ddd', backgroundColor: '#f1f1f1' }}>
                                                               Actual Target per Month
                                                            </th> */}

                                                            <th style={{ padding: '12px', border: '1px solid #ddd', backgroundColor: '#f1f1f1' }}>
                                                                In Time
                                                            </th>
                                                            <th style={{ padding: '12px', border: '1px solid #ddd', backgroundColor: '#f1f1f1' }}>
                                                                Out Time
                                                            </th>
                                                            <th style={{ padding: '12px', border: '1px solid #ddd', backgroundColor: '#f1f1f1' }}>
                                                                Working Hours
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {Array.isArray(modalData2) && modalData2.map((row, index) => (
                                                            <tr key={row.id}>
                                                                <td style={{ textAlign: 'center' }}>{index + 1}</td>
                                                                <td style={{ padding: '8px', border: '1px solid #ddd' }}>{row.date} </td>
                                                                <td style={{ padding: '8px', border: '1px solid #ddd' }}>{row.in_time}</td>
                                                                <td style={{ padding: '8px', border: '1px solid #ddd' }}>{row.out_time}</td>
                                                                <td style={{ padding: '8px', border: '1px solid #ddd' }}>{row.time}</td>
                                                            </tr>
                                                        ))}
                                                    </tbody>

                                                    <tfoot>
                                                        <tr>
                                                            <td colSpan="4" style={{ padding: '8px', border: '1px solid #ddd', fontWeight: 'bold' }}>Total Working Hours:</td>
                                                            <td style={{ padding: '8px', border: '1px solid #ddd', fontWeight: 'bold' }}>
                                                                {formatTotalTime(modalData2)}
                                                            </td>
                                                        </tr>
                                                    </tfoot>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </div>
    );
};

export default InvoiceGen;
